"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniMenuControls = void 0;
const ScaleUnit_1 = require("../../scale-unit/ScaleUnit");
const UiElements_1 = require("../../ui/UiElements");
const Webgl_1 = require("../../webgl/Webgl");
class MiniMenuControls {
    constructor(parentEl) {
        this.buttons = {
            navigation: {
                left: this.createButton('left', 'LEFT'),
                right: this.createButton('right', 'RIGHT'),
                top: this.createButton('top', 'TOP'),
                bottom: this.createButton('bottom', 'BOTTOM'),
                front: this.createButton('front', 'FRONT'),
                back: this.createButton('back', 'BACK'),
                center: this.createButton('center', 'CENTER'),
            },
            measurement: {
                distance: this.createRadioButton('distance', 'DISTANCE'),
                height: this.createRadioButton('height', 'HEIGHT'),
                angle: this.createRadioButton('angle', 'ANGLE'),
                area: this.createRadioButton('area', 'AREA'),
                clear: this.createButton('clear', 'RESET'),
            },
        };
        this.navigationElements = null;
        this.measurementElements = null;
        if (!parentEl) {
            throw new Error("Parent element (miniMenuContent) is undefined");
        }
        const elementsContainer = new UiElements_1.DivEl().setId('elementsContainer');
        const viewPositionContainer = new UiElements_1.DivEl()
            .setClass('controls')
            .addChild(new UiElements_1.DivEl()
            .setClass('title')
            .addAttribute('data-i18n-key', 'NAVIGATION'));
        const measurementsContainer = new UiElements_1.DivEl()
            .setId('measurementControls')
            .setClass('controls')
            .addChild(new UiElements_1.DivEl()
            .setClass('title')
            .addAttribute('data-i18n-key', 'MEASUREMENT'));
        const unitsContainer = new UiElements_1.DivEl()
            .setId('scaleUnit')
            .setClass('controls');
        new ScaleUnit_1.ScaleUnit(Webgl_1.Webgl.getInstance(), unitsContainer.domEl);
        this.measurementElements = this.createElements('measurement');
        this.navigationElements = this.createElements('navigation');
        measurementsContainer.addChild(this.measurementElements);
        viewPositionContainer.addChild(this.navigationElements);
        elementsContainer.domEl.append(viewPositionContainer.domEl, measurementsContainer.domEl, unitsContainer.domEl);
        parentEl.appendChild(elementsContainer.domEl);
    }
    createElements(name) {
        const elements = new UiElements_1.DivEl().setId(name);
        Object.keys(this.buttons[name]).forEach(key => {
            elements.addChild(this.buttons[name][key]);
        });
        return elements;
    }
    dispose() {
        // this.fullscreenBtn?.domEl.remove();
    }
    createRadioButton(icon, tooltip) {
        const radioEl = new UiElements_1.RadioEl('', 'measure');
        return new UiElements_1.LabelEl('')
            .setClass('icon')
            .addChild(radioEl)
            .addAttribute('data-i18n-attr', `data-title=${tooltip}`)
            .addChild(new UiElements_1.IconEl(icon));
    }
    createButton(iconName, tooltip, extraClass = '') {
        const btn = new UiElements_1.ButtonEl()
            .addAttribute('data-i18n-attr', `data-title=${tooltip}`)
            .addChild(new UiElements_1.IconEl(iconName));
        if (extraClass) {
            btn.setClass(extraClass);
        }
        return btn;
    }
}
exports.MiniMenuControls = MiniMenuControls;
